/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import '../styles/Navbar.css';
import logo from '../logo.svg';
import { Container } from 'react-bootstrap';

export default function Navbar() {
    return (
        <Container>
            <nav style={{ height: '100px' }} className="d-flex m-0 px-5 py-3 justify-content-between align-items-center">
                <a className='logo' href="#">
                    <img src={logo} alt='Logo' width='60' />
                </a>
                <a href='#contact'>
                    <button className='hireme'>Say Hi</button>
                </a>
            </nav>
        </Container>
    );
};